import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { Configurations } from '../../../Utils/Configurations';
import axios from 'axios';
import update from 'immutability-helper';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import PodcastPrograms from "../../../Components/Podcast-Programs/Podcast-Programs";
import qs from 'qs';
import Pagination from 'rc-pagination';
import Usuario from '../../../Utils/Usuario';

class PodcastProgramsList extends Component {
    constructor(props) {
        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.carregaListaProgramas = this.carregaListaProgramas.bind(this);
        this.cadastraPrograma = this.cadastraPrograma.bind(this);
        this.refreshTablePrograms = this.refreshTablePrograms.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.confirmaStatusPublicacao = this.confirmaStatusPublicacao.bind(this);
        this.mudaStatusPrograma = this.mudaStatusPrograma.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.selecionaPrograma = this.selecionaPrograma.bind(this);
        this.onChangePage = this.onChangePage.bind(this);

        this.state = {
            openModal: false,
            nomePrograma: '',
            descricaoPrograma: '',
            urlImagem: '',
            nomeMidia: 'Podcast',
            listaProgramas: [],
            paginasProgramas: 1,
            limite: 5,
            pagina: 0,
            hasError: false,
            errorMessage: '',
            isLoadingNovoPrograma: false,
        }
        this.Configurations = new Configurations();
    }

    componentWillMount() {
        let _permissoes = [1, 4, 11, 14, 20];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!found && !foundStatistic) {
            this.props.history.push({ pathname: '/permissao-negada' })
        } else {
            const _idPodcastPrograma = this.props.match.params.idPodcastPrograma;
            this.carregaListaProgramas(_idPodcastPrograma)
            this.setState({ permissaoEdicaoPodcast: found })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.carregaListaProgramas();
        }
    }


    toggleModal() {
        this.setState({
            openModal: !this.state.openModal
        })
    }


    toggleStatusPublicacao() {
        this.setState({
            openModalStatus: !this.state.openModalStatus
        })
    }
    confirmaStatusPublicacao(programa) {
        this.toggleStatusPublicacao();
        this.setState({
            nomeProgramaStatusPublicacao: programa.nome,
            idPodcastProgramaStatusPublicacao: programa.idPoadcast,
            flagStatusPublicacao: programa.habilitado
        })
    }

    mudaStatusPrograma() {
        const _index = this.state.listaProgramas.findIndex(item => item.idPoadcast === this.state.idPodcastProgramaStatusPublicacao);

        this.setState({ listaProgramas: update(this.state.listaProgramas, { [_index]: { loading: { $set: true } } }) })

        axios.put(this.Configurations.apiBasePath + `/podcasts/${this.state.idPodcastProgramaStatusPublicacao}`, { habilitado: !this.state.flagStatusPublicacao }).then(response => { })
            .catch(this.handleError).finally(() => {
                this.carregaListaProgramas({ page: this.state.pagina, pageSize: this.state.limite });
                this.toggleStatusPublicacao();
                this.setState({
                    listaProgramas: update(this.state.listaProgramas, { [_index]: { loading: { $set: false } } })
                })
            });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.msg })
    }
    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    carregaListaProgramas() {
        this.setState({ isLoadingProgramas: true })
        const values = qs.parse(window.location.search),
            limite = parseInt(values.limite, 10),
            pagina = parseInt(values["?pagina"], 10);
        axios.get(this.Configurations.apiBasePath + `/podcasts?pageSize=${limite}&page=${pagina}`).then(response => {
            this.setState({
                listaProgramas: response.data.podcastProgramas,
                paginasProgramas: response.data.paginacao.totalPaginas,
                limite: limite,
                pagina: pagina
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingProgramas: false
        }));
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    refreshTablePrograms(o) {
        this.carregaListaProgramas(o);
    }

    // cadastraPrograma() {
    //     this.setState({ isLoadingNovoPrograma: true })
    //     const info = {
    //         nome: this.state.nomePrograma,
    //         descricao: this.state.descricaoPrograma,
    //         imagem: this.state.urlImagem,

    //     }
    //     axios.post(this.Configurations.apiBasePath + `/podcasts`, info).then(response => {
    //         this.carregaListaProgramas();
    //     }).catch(this.handleError).finally(() => {
    //         this.setState({ isLoadingNovoPrograma: false })
    //         this.toggleModal();
    //     })

    // }

    cadastraPrograma() {
        const info = {
            nome: this.state.nomePrograma,
            descricao: this.state.descricaoPrograma,
            imagem: this.state.urlImagem,
        }
        axios.post(this.Configurations.apiBasePath + `/podcasts`, info).then(response => {
            this.carregaListaProgramas();
            this.toggleModal();
            this.setState({
                nomePrograma: '',
                descricaoPrograma: '',
                urlImagem: ''
            })
        }).catch(this.handleError).finally(() => {
        });

    }


    selecionaPrograma(idPodcastPrograma) {
        this.props.history.push(`/multimidia/podcasts/${idPodcastPrograma}?pagina=1&limite=10`);
    }

    onChangePage(page) {
        this.setState({
            pagina: page,
        }, () => {
            this.props.history.push({ pathname: `/multimidia/podcasts`, search: `?pagina=${this.state.pagina}&limite=${this.state.limite}` })
        });
    }

   
    render() {
        return (
            <div className="row programs-list">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">{this.state.nomeMidia} - Lista de Programas</h2>
                            <h4 className="d-lg-none">{this.state.nomeMidia}</h4>
                            <h5 className="d-lg-none">Lista de Programas</h5>
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    {this.state.permissaoEdicaoPodcast && (
                                        <button className="btn btn-outline-info mx-2" type="button" name="novaEdicao" onClick={this.toggleModal}>
                                            Cadastrar novo programa
                                        </button>
                                    )}
                                </div>
                            </div>
                            {this.state.permissaoEdicaoPodcast && (
                                    <button className="btn btn-outline-primary mx-2 mt-3" type="button" name="destaques" onClick={() => this.props.history.push({pathname: 'destaques/podcasts'})}>
                                        Destaques
                                    </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className={`col-12 text-center text-lg-left`}>
                    <p className="py-2 m-0">Clique no programa para obter informações sobre os episódios.</p>
                </div>
                {this.state.isLoadingProgramas ? (
                    <div className="col-12 text-center px-3 py-5">
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                ) : (
                    <div className="col-12">
                        <div className="row lista-programas">
                            {!!this.state.listaProgramas && this.state.listaProgramas.map((item, index) => {
                                return (
                                    <div className="col-12 py-2" key={index}>
                                        <PodcastPrograms
                                            item={item}
                                            confirmaStatusPublicacao={this.confirmaStatusPublicacao}
                                            selecionaPrograma={this.selecionaPrograma}
                                            permissaoEdicaoPodcast={this.state.permissaoEdicaoPodcast}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}

                {!this.state.isLoadingProgramas && this.state.listaProgramas && this.state.listaProgramas.length > 0 && (
                    <div className="col-12 mt-2 px-0">
                        <div className="paginacao-programas">
                            <Pagination onChange={this.onChangePage} current={this.state.pagina} total={this.state.paginasProgramas * this.state.limite} pageSize={this.state.limite} />
                        </div>
                    </div>
                )}

                <Modal className="modal-new-edition" isOpen={this.state.openModal} toggle={this.toogleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <div className="row no-gutters">
                            <div className="col-12 d-none d-lg-block">
                                Cadastro de Novo Programa - {this.state.nomeMidia}
                            </div>
                            <div className="col-12 d-lg-none text-center">
                                <h5>Cadastro de Novo Programa</h5>
                            </div>
                            <div className="col-12 d-lg-none text-center">
                                <h6>{this.state.nomeMidia}</h6>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row no-gutters align-items-end">
                            <div className="col-12 col-lg-12 px-1 py-1">
                                <label>Nome do programa:</label>
                                <input autoComplete="off" name="nomePrograma" className="form-control input-edicao" type="text" value={this.state.nomePrograma} onChange={this.handleOnChange} />
                            </div>
                            <div className="col-12 col-lg-12 px-1 py-1">
                                <label>Descrição do programa:</label>
                                <input autoComplete="off" name="descricaoPrograma" className="form-control input-edicao" type="text" value={this.state.descricaoPrograma} onChange={this.handleOnChange} />
                            </div>
                            <div className="col-12 col-lg-12 px-1 py-1">
                                <label>Url para imagem de capa:</label>
                                <input autoComplete="off" name="urlImagem" className="form-control input-edicao" type="text" value={this.state.urlImagem} onChange={this.handleOnChange} />
                            </div>
                            <div className="col-12 col-lg-12 pt-3 text-center text-lg-right">
                                {this.state.isLoadingNovoPrograma ? (
                                    <div className="spinner-border text-primary" role="status" />
                                ) : (
                                    <button onClick={this.cadastraPrograma} disabled={this.state.nomePrograma.trim() === ''} className="btn btn-outline-success">cadastrar programa</button>
                                )}
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal className="modal-new-edition" isOpen={this.state.openModalStatus} toggle={this.toggleStatusPublicacao}>
                    <ModalHeader toggle={this.toggleStatusPublicacao}>
                        Mudança de Status do Programa
                    </ModalHeader>
                    <ModalBody>
                        {this.state.flagStatusPublicacao === false ? (
                            <p className="m-0">{`Deseja confirmar a publicação do programa ${this.state.nomeProgramaStatusPublicacao}?`}</p>
                        ) : (
                            <p className="m-0">{`Deseja desabilitar o programa ${this.state.nomeProgramaStatusPublicacao}?`}</p>
                        )}

                    </ModalBody>

                    <ModalFooter>
                        {this.state.isLoadingStatusPrograma ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingStatusPrograma} color={`${this.state.flagStatusPublicacao === false ? `success` : `danger`}`} onClick={this.mudaStatusPrograma}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ openModalStatus: !this.state.openModalStatus })}>voltar</Button>
                    </ModalFooter>
                </Modal>
               
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}
export default PodcastProgramsList;